import { render, staticRenderFns } from "./DashboardVisitasNcoor.vue?vue&type=template&id=57a97794&scoped=true"
import script from "./DashboardVisitasNcoor.vue?vue&type=script&lang=js"
export * from "./DashboardVisitasNcoor.vue?vue&type=script&lang=js"
import style0 from "./DashboardVisitasNcoor.vue?vue&type=style&index=0&id=57a97794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a97794",
  null
  
)

export default component.exports